var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{staticClass:"!gl-px-3",attrs:{"aria-label":_vm.ariaLabel,"href":_vm.href,"icon":_vm.icon,"category":"tertiary","button-text-classes":['!gl-overflow-visible']}},[_c('span',{staticClass:"gl-text-sm gl-font-semibold"},[_vm._v("\n    "+_vm._s(_vm.formattedCount)+"\n  ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }